export default __webpack_public_path__ + "book_details-dimensions.a5ae2781.png";